'use client';

import LoaderIcon from '@src/v3/components/loader/LoaderIcon';
import React from 'react';

function Loading() {
  return (
    <div className="flex justify-center items-center sm:h-screen max-sm:h-[100dvh]">
      <div className="relative">
        <LoaderIcon />
      </div>
    </div>
  );
}

export default Loading;
